import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DriverListItemComponent } from './driver-list-item.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [DriverListItemComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule],
  exports: [DriverListItemComponent],
})
export class DriverListItemModule {}
